module.exports = __webpack_public_path__ + "static/media/12.4556e195.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/lhand/12.png
// module id = 752
// module chunks = 0